import { Alert } from '@innovationnorway/cl-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ClusterMemberCreateDto } from 'src/api/v2';

type Props = {
  items: ClusterMemberCreateDto[];
};

const ImportMembersSuccessMessage: React.FC<Props> = ({ items }) => {
  const { t: tResourceBase } = useTranslation('resourceBase');

  if (items.length === 0) {
    return null;
  }

  return (
    <Alert data-color="success" className="margin-bottom--3">
      <p>
        {items.length} {items.length > 1 ? tResourceBase('customers') : tResourceBase('customer')}{' '}
        {tResourceBase('readyForImport')}.
      </p>
    </Alert>
  );
};

export default ImportMembersSuccessMessage;
